import React, { Component } from 'react'
import NavBar from '../common/navBar/NavBar'
import ComingSoon from './ComingSoon'
import Product from './Product'
import d0_image from '../../public/image/device0.svg'
import d1_image from '../../public/image/device1.svg'
import Terms from '../common/terms/Terms'
import Footer from '../common/footer/Footer'
import './Home.css'

export default class Home extends Component {
  render() {
    return (
      <div className='home'>
        <NavBar />
        <ComingSoon />
        <Product
          name='Device0'
          subtitle='Beginning. New.'
          image={d0_image}
          brightness='dark-brightness'
        />
        <Product
          name='Device1'
          subtitle='More. Beginning.'
          image={d1_image}
          brightness='light-brightness'
        />
        <Terms />
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/home/Home.js